import styled from '@emotion/styled'

export const MultiBetLegPriceStyled = styled.span({
  fontSize: '1.4rem',
  fontWeight: 'bold',
  lineHeight: 1,
})
